import React from 'react';

const IconOptimization = () => (
  <svg
    fill="none"
    viewBox="0 0 100.00 100.00"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.6"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <g id="network"></g> <g id="connection"></g> <g id="page"></g> <g id="support"></g>
      <g id="configuration"></g> <g id="cloud_storage"></g> <g id="password"></g>
      <g id="search_engine"></g> <g id="history"></g> <g id="SEO"></g> <g id="optimization"></g>
      <g id="backlink"></g>
      <g id="performance">
        <path d="M50,19C25.1,19,4.9,38.5,4,63.4C4,64.8,5.2,66,6.6,66c1.2,0,2.2-0.8,2.6-2c4-14.2,17-24,31.8-24c6.9,0,13.5,2.1,19.1,6.1 l-17.6,17C42,63.1,41.5,63,41,63c-5,0-9,4-9,9s4,9,9,9s9-4,9-9c0-0.5-0.1-1-0.1-1.5l14-21.3c4.2,4.1,7.3,9.2,8.9,14.8 c0.3,1.2,1.4,2,2.6,2h18c0.7,0,1.4-0.3,1.9-0.8c0.5-0.5,0.8-1.2,0.7-1.9C95,38.5,74.8,19,50,19z M67.9,24.8L55.4,41.1 c-4.2-1.9-8.7-3-13.4-3.1V21.7c2.6-0.5,5.2-0.7,8-0.7C56.4,21,62.4,22.4,67.9,24.8z M27.9,40.6l-4.8-10.5 c4.9-3.8,10.6-6.5,16.9-7.9V38C35.8,38.1,31.7,39,27.9,40.6z M7.3,63.5C7.2,63.8,6.9,64,6.6,64C6.3,64,6,63.7,6,63.4 c0.2-6.1,1.7-11.9,4.1-17.1l4.9,3.3C11.5,53.5,8.8,58.2,7.3,63.5z M16.4,48.1L11,44.5c2.6-5,6.2-9.5,10.5-13.1l4.5,10 C22.5,43,19.2,45.3,16.4,48.1z M41,79c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S44.9,79,41,79z M44.7,63.8l19.6-18.9L62.9,47 c0,0,0,0,0,0c-0.1,0.1-0.1,0.2-0.1,0.2L49.1,68.1C48.2,66.2,46.6,64.6,44.7,63.8z M64.9,47.5l5.9-9c0.3-0.4,0.2-1-0.2-1.3 s-1-0.3-1.3,0l-7.7,7.4c-1.4-1-2.8-1.9-4.3-2.7l12.5-16.3c7.1,3.6,13.1,9,17.4,15.6l-19.5,8.8c0,0-0.1,0.1-0.1,0.1 C66.7,49.2,65.8,48.4,64.9,47.5z M93.8,63.8c-0.1,0.1-0.3,0.2-0.5,0.2h-18c-0.3,0-0.5-0.2-0.6-0.5c-1.2-4.3-3.2-8.2-5.9-11.7 L88.2,43c3.4,6,5.5,12.9,5.8,20.3C93.9,63.6,93.8,63.7,93.8,63.8z"></path>
      </g>
      <g id="analytics"></g> <g id="security"></g> <g id="dark_web"></g> <g id="video_player"></g>
      <g id="upload_download"></g> <g id="incognito_tab"></g> <g id="bookmark"></g>
    </g>
  </svg>
);

export default IconOptimization;
